
import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-issue-credit-voucher-very-brifly-officer-report',
  templateUrl: './issue-credit-voucher-very-brifly-officer-report.component.html',
  styleUrls: ['./issue-credit-voucher-very-brifly-officer-report.component.scss'],
})
export class IssueCreditVoucherVeryBriflyOfficerReportComponent implements OnInit {

  startDate: any;
  endDate: any;
  repName: any;
  issueName: any;
  issueDates: any;
  offRepName: any;
  reportType:any;

  PaymentadvtOffInDFormBenas: any[] = [];
  PaymentadvtOffInDTotal2: number = 0;
  PaymentadvtOffInDTotal3:any;
  advtFormBeans: any;
  advtVBTotal: number;
  advtVBInvoTotal: number;
  constructor(
    private dialogRef: MatDialogRef<IssueCreditVoucherVeryBriflyOfficerReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) {
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.repName = data.repName;
    this.issueName = data.issuename;
    this.issueDates = data.issueDates;
    this.offRepName = data.offRepName;
    this.reportType=data.reportType;

    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
    console.log('Rep Name:', this.repName);
    console.log('Issue Name:', this.issueName);
    console.log('Issue Date:', this.issueDates);
    console.log('Off Rep Name:', this.offRepName);
   console.log('reportType:',this.reportType);
  }

  ngOnInit(): void {
    const req = {
 
      rep_name: this.repName,
      startDate: this.startDate,
      endDate: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: this.issueName,
      issue_Date: this.issueDates
    
    };

    this.service.getissueOfficerVb(req).subscribe((data:any) => {
      console.log("ADVT Data=",data);
    this.advtFormBeans = (data as any);;

    // Reset totals
    this.advtVBTotal = 0;
    this.advtVBInvoTotal=0;

    // Calculate totals
    for (let repData of this.advtFormBeans) {
        for (let data1 of repData.rep_data) {
            this.advtVBTotal += parseInt(data1.rcv_amt) || 0;
    
            
        }
    }
    });
      (error) => {
        console.error('Error fetching briefly data:', error);
        this.toaster.error('Failed to load brief report', 'Error');
      }
    
  }
  PaymentadvtOffInDTotal(arg0: string, PaymentadvtOffInDTotal: any) {
    throw new Error('Method not implemented.');
  }

  exportExcel(fileName: string) {
    // Get the table element
    const element = document.getElementById('print-section');
    if (!element) {
      this.toaster.error('Table not found!');
      return;
    }
  
    // Use XLSX to convert the table to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Write workbook and save as Excel file
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}

